'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-edit', {
      url: '/document/edit/:id',
      template: '<document-edit></document-edit>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/edit/document-edit.routes.js